import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesOrderLineAudit, UnStickResult } from '../../models';
import { TmsWebBaseService } from '../base';

/**
 * The sales order line audit (Sales Order What's Happened, requirements 4-6, 10, 15) and its
 * Un-stick action. Everything the screen words comes back as codes plus parameters (D-9).
 */
@Injectable({
  providedIn: 'root',
})
export class SalesOrderLineAuditService extends TmsWebBaseService {
  constructor() {
    super('SalesOrderLineAudit');
  }

  /** The verdict, milestones, timeline, documents and stock of one sales order line. */
  getAudit(salesOrderLineId: string): Observable<SalesOrderLineAudit> {
    return this.httpService.get<SalesOrderLineAudit>(`${this.apiUrl}/${salesOrderLineId}`);
  }

  /** Re-derives the line's demand when its rule allows it. Always a 200 with an UnStickResults code. */
  unStick(salesOrderLineId: string): Observable<UnStickResult> {
    return this.httpService.post<UnStickResult>(`${this.apiUrl}/UnStick/${salesOrderLineId}`, {});
  }
}
